import { useMutation } from '@tanstack/react-query'

import { deleteMerchantOrgBlockList } from '@src/api'
import { DefaultApiDeleteMerchantOrgBlockListRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteMerchantOrgBlockList = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDeleteMerchantOrgBlockListRequest) =>
      deleteMerchantOrgBlockList(axiosInstance, params),
  })
}
